import React from "react";

import { Alert, Spinner } from "@amzn/awsui-components-console";

import { NO_ITEMS_FOUND } from "src/constants/CommonConstants";

import { ErrorLoaderProps } from "./errorLoader.interface";
import "./errorLoader.scss";


function ErrorLoader({
  className,
  isLoading,
  error,
  isAlert = true
}: ErrorLoaderProps): JSX.Element {
  
  if (!(error || isLoading)) {
    return <></>;
  }
  const ERROR_MESSAGE = error || NO_ITEMS_FOUND
  return (
    <div className={`${className} errLoadrCmpt`}>
      {isLoading && <Spinner size="large" />}
      {!isLoading && error && (isAlert ? <Alert type="error">{ERROR_MESSAGE}</Alert> : <p id="errorMsg">{ERROR_MESSAGE}</p>)}
    </div>
  );
}
export default ErrorLoader;
